import Text from '@web-ui-kit/text'
import { useTranslation } from 'react-i18next'
import ButtonIcon from '@web-ui-kit/icon-button'
import Icon from '@web-ui-kit/icon'
import useMediaQuery from '@web-ui-kit/hooks.use-media-query'
import AlertCenter from '@web-ui-kit/alert-center'
import * as Sc from './NotificationsSystem.style'
import NotificationsTop from 'app/components/NotificationsTop'
import useCheckCanary from 'hooks/useCheckCanary'
import useNotifications from 'components/Header/hooks/useNotifications'

const NotificationsSystem = () => {
  const { t } = useTranslation()
  const { isExtraSmall } = useMediaQuery()
  const { counter, alerts } = useNotifications()
  const showNewAlertCenter = useCheckCanary(
    window?.rebranding?.canaryUsers,
    window?.rebranding?.enableAlerteCenter
  )

  if (showNewAlertCenter) {
    const emptyData = {
      description: t('No hay notificaciones por ahora'),
      title: t('¡Estás al día!'),
    }
    return (
      <Sc.ButtonIconContainer>
        <AlertCenter
          alerts={alerts}
          buttonProps={{
            dataTestId: 'alert-center-button',
            icon: 'notification',
            id: 'alert-center-button',
          }}
          empty={emptyData}
          title={t('Mis notificaciones')}
          type={isExtraSmall ? 'dialog' : 'popover'}
        />
        {Boolean(counter) && (
          <Sc.ButtonIconBadge>
            <Text bold variant={'superSmall'}>
              {counter}
            </Text>
          </Sc.ButtonIconBadge>
        )}
      </Sc.ButtonIconContainer>
    )
  }

  return (
    <Sc.NotificationsContainer>
      <Sc.NotificationsHeader>
        <Text bold variant={'body'}>
          {t('Mis Notificaciones')}
        </Text>
        <ButtonIcon icon={<Icon icon='close' />} onClick={() => {}} />
      </Sc.NotificationsHeader>
      <Sc.NotificationsContent>
        <Sc.Scroller>
          <NotificationsTop />
        </Sc.Scroller>
      </Sc.NotificationsContent>
    </Sc.NotificationsContainer>
  )
}

export default NotificationsSystem
